<template>
<v-main>
  <v-dialog
    width=500
    v-model="dialog"
    persistent
    overlay-opacity=0.9>
      <v-card 
        height=320
        class="elevation-12 mx-auto">
        <div class="py-3 blueDark">
          <v-img contain
            height=20
            :src="logo"></v-img>
        </div>
          <v-progress-linear
              v-show="recovery_procedure && !sms_code"
              :indeterminate="!sms_code || sms_code.lenght < lenSmsCode"
              color="orangeMain"></v-progress-linear>
        <v-card-text class="mt-12">
          <v-form>
  <!-- Авторизация -->
            <v-text-field autofocus
              v-model="username"
              :label="username.match(/\+/) ?
                      'номер телефона' : username.match(/\@/) ?
                      'email' : 'номер телефона или email'"
              :prepend-icon="username.match(/\+/) ?
                            'phone_iphone' : username.match(/\@/) ?
                            'email' : 'person'"
              id="username"
              name="username"
              color="blueMain">
            </v-text-field>

            <v-text-field
              v-show="!recovery_procedure"
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text': 'password'"
              @click:append="showPassword = !showPassword"
              color="blueMain"
              id="password"
              label="пароль"
              name="password"
              prepend-icon="lock">
            </v-text-field>

            <span class="red--text">{{error}}</span>
  <!-- СМС код -->
            <v-text-field autofocus
                v-if="recovery_procedure && sms_code.length < lenSmsCode"
                v-model="sms_code"
                color="blueMain"
                id="sms_code"
                label="код из СМС"
                name="sms_code"
                prepend-icon="sms"
                type="text"
            ></v-text-field>

  <!-- Новый пароль -->
            <v-text-field autofocus
                v-show="sms_code && sms_code.length >= lenSmsCode"
                v-model="new_password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text': 'password'"
                :rules="[rules.required, rules.min]"
                @click:append="showPassword = !showPassword"
                id="new_password"
                color="blueMain"
                label="новый пароль"
                name="sms_code"
                prepend-icon="lock"
            >
            </v-text-field>
          </v-form>
        </v-card-text>

  <!-- Кнопка продолжить -->
        <v-card-actions class="pt-0">

          <v-btn dark text
            class="ml-3"
            color="blueGrey"
            v-on:click="recovery_procedure = true"
            v-show="!password && username.length > 2 &&
            !recovery_procedure && username.match(/\+/)"
            >Забыл пароль?</v-btn>

          <v-spacer></v-spacer>
          <v-btn dark
            class="mr-3"
            color="orangeMain"
            v-on:click="auth()"
            v-show="password.length >= lenPassword && username.length > 2 || new_password.length >= lenPassword">
            Продолжить</v-btn>
        </v-card-actions>
      </v-card>

      <!--  -->
      <!--  -->
      <!-- <v&#45;card> -->
      <!--     <v&#45;card&#45;title -->
      <!--         primary&#45;title -->
      <!--         > -->
      <!--     </v&#45;card&#45;title> -->
      <!--  -->
      <!--     <v&#45;card&#45;text> -->
      <!--         <v&#45;row> -->
      <!--         <v&#45;col cols="12" sm="6" md="6"> -->
      <!--             <v&#45;text&#45;field -->
      <!--               autofocus -->
      <!--               color="orangeDark" -->
      <!--               label="Логин" -->
      <!--               v&#45;model="username"></v&#45;text&#45;field> -->
      <!--         </v&#45;col> -->
      <!--         <v&#45;col cols="12" sm="6" md="6"> -->
      <!--             <v&#45;text&#45;field -->
      <!--               color="orangeDark" -->
      <!--               label="Пароль" -->
      <!--               v&#45;model="password" -->
      <!--               v&#45;on:keyup.enter="auth()" -->
      <!--               ></v&#45;text&#45;field> -->
      <!--         </v&#45;col> -->
      <!--     </v&#45;row> -->
      <!--     </v&#45;card&#45;text> -->
      <!--  -->
      <!--     <v&#45;card&#45;actions> -->
      <!--     <v&#45;spacer></v&#45;spacer> -->
      <!--     <v&#45;btn -->
      <!--         color="orangeDark" -->
      <!--         dark -->
      <!--         @click="auth()"> -->
      <!--         продолжить -->
      <!--     </v&#45;btn> -->
      <!--     </v&#45;card&#45;actions> -->
      <!-- </v&#45;card> -->


  </v-dialog>
</v-main>
</template>

<script>

import {mapState, mapMutations} from 'vuex';
export default {
name: 'Login',

props: {
},

data: () => ({
    dialog: true,
    username: '',
    password: '',
    showPassword: false,
    rules: {
            required: value => !!value || 'введите новый пароль',
            min: v => v.length >= 8 || 'меньше 8 символов'
          },
    lenPassword: 6,
    lenSmsCode: 4,
    lenPhone: 10,
    drawer: null,
    recovery_procedure: false,
    new_password: "",
    sms_code: "",
    error: '',
    logo: "http://251317.selcdn.ru/oboi.ru/logo/%D0%BB%D0%BE%D0%B3%D0%BE%20%D0%BE%D1%81%D0%BD%D0%BE%D0%B2%D0%BD%D0%BE%D0%B9.png"

}),

computed: {
        ...mapState(['user', 'access', 'shop']),
},

methods: {
  ...mapMutations(['set_username']),

  async auth () {
    fetch('https://auth.oboi.ru/token/login', {
          method: 'POST',
          body: JSON.stringify({"username": this.username,
                                "password": this.password})
      }).then(res => res.json())
        .then(json => {
          if (json['access_token']){
              localStorage.setItem("access_token",
                                   json['access_token']);
          }
          if (json['refresh_token']){
              localStorage.setItem("refresh_token",
                                   json['refresh_token']);
              this.dialog = false;
              this.set_username(this.username);
              this.$router.name == 'Login' ?
                this.$router.go(-1) : this.$router.push({path: '/shoplist'});
          }  else this.error = json.response;
      })
    }
},

watch: {

},

created: function() {
},

mounted() {
},

    
}
</script>
